import { render, staticRenderFns } from "./create-dropdown.vue?vue&type=template&id=32e5ae16&scoped=true&"
import script from "./create-dropdown.vue?vue&type=script&lang=js&"
export * from "./create-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./create-dropdown.vue?vue&type=style&index=0&id=32e5ae16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e5ae16",
  null
  
)

export default component.exports